import date from './date'

const modified =
{
    ...date,
    label : 'Modifié : {0}'
};

export default modified ;
